import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, } from 'rxjs/operators';

import { ErrorService } from 'src/app/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';

import { GlobalComponent } from 'src/app/global/global.component';
import { GetTaxListBO } from '../taxs-details.modal';

@Injectable({
  providedIn: 'root'
})
export class RelationshipListDateService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent) {
    super();
  }
  public execute(RLstate: GetTaxListBO): void {
    this.getRelationshipList(RLstate).subscribe(x => super.next(x));
  }
  getRelationshipList(RLstate?: GetTaxListBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Relationship/GetRelationships?", RLstate)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      ))
  }
}
